// extracted by mini-css-extract-plugin
export default {"chart_wrap":"SectorGraph_chart_wrap__eV-fj","chart_header":"SectorGraph_chart_header__dA3h1","label":"SectorGraph_label__vNUPR","chart_footer":"SectorGraph_chart_footer__GbirL"};